<template>
  <div>
    <ValidationObserver ref="form">
      <form @submit.prevent="handleSubmit">
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-tabs alignment="right" v-model="restaurantCurrentLanguage">
              <vs-tab
                v-if="languages[lang]"
                @click="clickTabChangeLang(lang)"
                :label="languages[lang]"
                v-for="lang in restaurantForm.allowedLanguages"
              >
              </vs-tab>
            </vs-tabs>
          </div>
          <ValidationProvider name="id" v-slot="{ errors }" class="hidden">
            <vs-input v-model="restaurantForm.id" type="hidden" />
          </ValidationProvider>
          <div class="vx-col md:w-1/3 w-full">
            <vx-input-group class="mb-5 mt-3">
              <ValidationProvider name="Url Restaurante" rules="required|alpha_dash|slugRestaurant:@id" v-slot="{ errors }">
                <vs-input
                  label-placeholder="Url del restaurante (ej: barify.es/rest/NOMBRERESTAURANTE)"
                  v-model="restaurantForm.slug"
                  class="w-full"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </ValidationProvider>
            </vx-input-group>
          </div>
          <div class="vx-col w-full mt-6 mb-3">
            <h4 class="text-uppercase font-bold text-xl">{{ $t('restaurant.RestauranteInfo') }}</h4>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <vx-input-group class="mb-5 mt-3">
              <ValidationProvider name="Nombre" rules="required" v-slot="{ errors }">
                <vs-input label-placeholder="Nombre" v-model="restaurantForm.name" required="true" class="w-full" />
                <p class="text-danger">{{ errors[0] }}</p>
              </ValidationProvider>
            </vx-input-group>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <vx-input-group class="mb-5 mt-3">
              <ValidationProvider name="CIF" rules="required" v-slot="{ errors }">
                <vs-input label-placeholder="CIF" v-model="restaurantForm.cif" required="true" class="w-full" />
                <p class="text-danger">{{ errors[0] }}</p>
              </ValidationProvider>
            </vx-input-group>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <vx-input-group class="mb-5 mt-3">
              <ValidationProvider name="Empresa" rules="required" v-slot="{ errors }">
                <vs-input
                  label-placeholder="Empresa"
                  v-model="restaurantForm.company_name"
                  required="true"
                  class="w-full"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </ValidationProvider>
            </vx-input-group>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <vx-input-group class="mb-5 mt-3">
              <ValidationProvider name="Teléfono de reservas" rules="min:9|max:12" v-slot="{ errors }">
                <vs-input
                  label-placeholder="Teléfono de reservas"
                  v-model="restaurantForm.phone_bookings"
                  class="w-full"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </ValidationProvider>
            </vx-input-group>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <vx-input-group class="mb-5 mt-3">
              <ValidationProvider name="Teléfono de gestión" rules="required|min:9|max:12" v-slot="{ errors }">
                <vs-input
                  label-placeholder="Teléfono de gestión"
                  v-model="restaurantForm.phone_management"
                  required="true"
                  class="w-full"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </ValidationProvider>
            </vx-input-group>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <vx-input-group class="mb-5 mt-3">
              <ValidationProvider name="Whatsapp" rules="min:9|max:12" v-slot="{ errors }">
                <vs-input :label-placeholder="$t('Whatsapp')" v-model="restaurantForm.whatsapp" class="w-full" />
                <p class="text-danger">{{ errors[0] }}</p>
              </ValidationProvider>
            </vx-input-group>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <vx-input-group class="mb-5 mt-3">
              <ValidationProvider name="Correo electrónico" rules="email" v-slot="{ errors }">
                <vs-input
                  label-placeholder="Correo electrónico"
                  v-model="restaurantForm.email"
                  required="true"
                  class="w-full"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </ValidationProvider>
            </vx-input-group>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <vx-input-group class="mb-5 mt-3">
              <ValidationProvider name="Web" rules="web" v-slot="{ errors }">
                <vs-input label-placeholder="Web" v-model="restaurantForm.web" required="true" class="w-full" />
                <p class="text-danger">{{ errors[0] }}</p>
              </ValidationProvider>
            </vx-input-group>
          </div>
          <div class="vx-col w-full">
            <vx-input-group class="mb-2 mt-3">
              <p>{{ $t('Descripcion') }}</p>
              <vs-textarea v-model="restaurantForm.description" rows="6" />
            </vx-input-group>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <vx-input-group class="mb-5 mt-3">
              <ValidationProvider name="Tipo" rules="required" v-slot="{ errors }">
                <vs-select
                  autocomplete
                  label="Tipo de cocina"
                  v-model="restaurantForm.types"
                  class="selectTypes w-full"
                  multiple
                >
                  <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item, index) in listTypes" />
                </vs-select>
                <p class="text-danger">{{ errors[0] }}</p>
              </ValidationProvider>
            </vx-input-group>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <vx-input-group class="mb-5 mt-3">
              <ValidationProvider name="Perfil" rules="required" v-slot="{ errors }">
                <vs-select
                  autocomplete
                  label="Perfil"
                  v-model="restaurantForm.profiles"
                  class="selectProfiles w-full"
                  multiple
                >
                  <vs-select-item
                    :key="index"
                    :value="item.id"
                    :text="item.name"
                    v-for="(item, index) in listProfiles"
                  />
                </vs-select>
                <p class="text-danger">{{ errors[0] }}</p>
              </ValidationProvider>
            </vx-input-group>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <vx-input-group class="mb-5 mt-3">
              <ValidationProvider name="Idiomas" rules="required" v-slot="{ errors }">
                <vs-select
                  autocomplete
                  label="Idiomas"
                  v-model="restaurantForm.languages"
                  class="selectProfiles w-full"
                  multiple
                >
                  <vs-select-item
                    :key="index"
                    :value="item.id"
                    :text="item.name"
                    v-for="(item, index) in listLanguages"
                  />
                </vs-select>
                <p class="text-danger">{{ errors[0] }}</p>
              </ValidationProvider>
            </vx-input-group>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <vx-input-group class="mb-5 mt-3">
              <ValidationProvider name="IVA" rules="required|min_value:0" v-slot="{ errors }">
                <vs-input
                  min="0"
                  label-placeholder="IVA"
                  v-model="restaurantForm.iva"
                  required="true"
                  class="w-full"
                  type="number"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </ValidationProvider>
            </vx-input-group>
          </div>
          <div class="vx-col w-full mt-6 mb-3">
            <h4 class="text-uppercase font-bold text-xl">{{ $t('Responsables') }}</h4>
          </div>
          <div class="vx-col w-full mt-3">
            <h6>{{ $t('Principal') }}</h6>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <vx-input-group class="mb-5 mt-3">
              <ValidationProvider name="Nombre responsable" rules="required" v-slot="{ errors }">
                <vs-input
                  label-placeholder="Nombre"
                  v-model="restaurantForm.responsable_name"
                  required="true"
                  class="w-full"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </ValidationProvider>
            </vx-input-group>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <vx-input-group class="mb-5 mt-3">
              <ValidationProvider name="Teléfono responsable" rules="required" v-slot="{ errors }">
                <vs-input
                  label-placeholder="Teléfono"
                  v-model="restaurantForm.responsable_phone"
                  required="true"
                  class="w-full"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </ValidationProvider>
            </vx-input-group>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <vx-input-group class="mb-5 mt-3">
              <ValidationProvider name="Puesto responsable" rules="required" v-slot="{ errors }">
                <vs-input
                  label-placeholder="Puesto"
                  v-model="restaurantForm.responsable_position"
                  required="true"
                  class="w-full"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </ValidationProvider>
            </vx-input-group>
          </div>
          <div class="vx-col w-full">
            <h6>{{ $t('Secundario') }}</h6>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <vx-input-group class="mb-5 mt-3">
              <vs-input
                label-placeholder="Nombre"
                v-model="restaurantForm.responsable_name_2"
                required="true"
                class="w-full"
              />
            </vx-input-group>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <vx-input-group class="mb-5 mt-3">
              <ValidationProvider name="Teléfono secundario" rules="min:9|max:12" v-slot="{ errors }">
                <vs-input
                  label-placeholder="Teléfono"
                  v-model="restaurantForm.responsable_phone_2"
                  required="true"
                  class="w-full"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </ValidationProvider>
            </vx-input-group>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <vx-input-group class="mb-5 mt-3">
              <vs-input
                label-placeholder="Puesto"
                v-model="restaurantForm.responsable_position_2"
                required="true"
                class="w-full"
              />
            </vx-input-group>
          </div>
          <div class="vx-col w-full mt-6 mb-3">
            <h4 class="text-uppercase font-bold text-xl">{{ $t('Ubicacion') }}</h4>
          </div>
          <div class="vx-col md:w-2/3 w-full">
            <vx-input-group class="mb-5 mt-3">
              <ValidationProvider name="Dirección" rules="required" v-slot="{ errors }">
                <vs-input
                  label-placeholder="Dirección"
                  v-model="restaurantForm.address"
                  required="true"
                  class="w-full"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </ValidationProvider>
            </vx-input-group>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <vx-input-group class="mb-5 mt-3">
              <ValidationProvider name="Código postal" rules="required" v-slot="{ errors }">
                <vs-input
                  label-placeholder="Código postal"
                  v-model="restaurantForm.postalCode"
                  required="true"
                  class="w-full"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </ValidationProvider>
            </vx-input-group>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <vx-input-group class="mb-5 mt-3">
              <ValidationProvider name="Municipio" rules="required" v-slot="{ errors }">
                <vs-input
                  label-placeholder="Municipio"
                  v-model="restaurantForm.municipality"
                  required="true"
                  class="w-full"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </ValidationProvider>
            </vx-input-group>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <vx-input-group class="mb-5 mt-3">
              <ValidationProvider name="Provincia" rules="required" v-slot="{ errors }">
                <vs-input
                  label-placeholder="Provincia"
                  v-model="restaurantForm.province"
                  required="true"
                  class="w-full"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </ValidationProvider>
            </vx-input-group>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <vx-input-group class="mb-5 mt-3">
              <ValidationProvider name="País" rules="required" v-slot="{ errors }">
                <vs-input label-placeholder="País" v-model="restaurantForm.country" required="true" class="w-full" />
                <p class="text-danger">{{ errors[0] }}</p>
              </ValidationProvider>
            </vx-input-group>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <vx-input-group class="mb-5 mt-3">
              <ValidationProvider name="Latitud" rules="required" v-slot="{ errors }">
                <vs-input label-placeholder="Latitud" v-model="latitudeCalculate" required="true" class="w-full" />
                <p class="text-danger">{{ errors[0] }}</p>
              </ValidationProvider>
            </vx-input-group>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <vx-input-group class="mb-5 mt-3">
              <ValidationProvider name="Longitud" rules="required" v-slot="{ errors }">
                <vs-input label-placeholder="Longitud" v-model="longitudeCalculate" required="true" class="w-full" />
                <p class="text-danger">{{ errors[0] }}</p>
              </ValidationProvider>
            </vx-input-group>
          </div>
          <div class="vx-col md:w-1/3 w-full flex items-end">
            <div class="mb-5">
              <vs-button
                type="filled"
                color="primary"
                @click="calculateCoordenadas"
                class="btn-primary btn--xlarge-auto font-weight-bold"
              >
                {{ $t('CalcularCoordenadas') }}
              </vs-button>
            </div>
          </div>
          <div class="vx-col w-full mb-3 mt-6 mb-3">
            <h4 class="text-uppercase font-bold text-xl">{{ $t('Servicio') }}</h4>
          </div>
          <div class="vx-col w-full">
            <div class="vx-row">
              <div class="vx-col md:w-2/12 w-full mb-3">
                <label class="mt-2">{{ $t('services.Wifi') }}</label>
                <vs-switch v-model="restaurantForm.wifi" />
              </div>
              <div class="vx-col md:w-2/12 w-full mb-3">
                <label class="mt-2">{{ $t('services.Animacion') }}</label>
                <vs-switch v-model="restaurantForm.animation" />
              </div>
              <div class="vx-col md:w-2/12 w-full mb-3">
                <label class="mt-2">{{ $t('services.LibreDeCovid') }}</label>
                <vs-switch v-model="restaurantForm.covid_free" />
              </div>
              <div class="vx-col md:w-2/12 w-full mb-3">
                <label class="mt-2">{{ $t('services.MenuDigital') }}</label>
                <vs-switch v-model="restaurantForm.digital_menu" />
              </div>
              <div class="vx-col md:w-2/12 w-full mb-3">
                <label class="mt-2">{{ $t('services.EntregaComida') }}</label>
                <vs-switch v-model="restaurantForm.food_delivery" />
              </div>
              <div class="vx-col md:w-2/12 w-full mb-3">
                <label class="mt-2">{{ $t('services.NinosFriendly') }}</label>
                <vs-switch v-model="restaurantForm.kid_friendly" />
              </div>
              <div class="vx-col md:w-2/12 w-full mb-3">
                <label class="mt-2">{{ $t('services.AreaNinos') }}</label>
                <vs-switch v-model="restaurantForm.kid_area" />
              </div>
              <div class="vx-col md:w-2/12 w-full mb-3">
                <label class="mt-2">{{ $t('services.Parking') }}</label>
                <vs-switch v-model="restaurantForm.parking" />
              </div>
              <div class="vx-col md:w-2/12 w-full mb-3">
                <label class="mt-2">{{ $t('services.MascotasFriendly') }}</label>
                <vs-switch v-model="restaurantForm.pet_friendly" />
              </div>
              <div class="vx-col md:w-2/12 w-full mb-3">
                <label class="mt-2">PMR</label>
                <vs-switch v-model="restaurantForm.pmr" />
              </div>
              <div class="vx-col md:w-2/12 w-full mb-3">
                <label class="mt-2">{{ $t('services.Piscina') }}</label>
                <vs-switch v-model="restaurantForm.pool" />
              </div>
              <div class="vx-col md:w-2/12 w-full mb-3">
                <label class="mt-2">{{ $t('services.Privatizable') }}</label>
                <vs-switch v-model="restaurantForm.privatizable" />
              </div>
              <div class="vx-col md:w-2/12 w-full mb-3">
                <label class="mt-2">{{ $t('services.Terraza') }}</label>
                <vs-switch v-model="restaurantForm.terrace" />
              </div>
            </div>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <vx-input-group class="mb-5 mt-3">
              <ValidationProvider name="Aforo" rules="min_value:0" v-slot="{ errors }">
                <vs-input
                  label-placeholder="Aforo"
                  type="number"
                  v-model="restaurantForm.capacity"
                  required="true"
                  min="0"
                  class="w-full"/>
                <p class="text-danger">{{ errors[0] }}</p>
              </ValidationProvider>
            </vx-input-group>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <vx-input-group class="mb-5 mt-3">
            <ValidationProvider name="Número de mesas" rules="min_value:0" v-slot="{ errors }">
              <vs-input
                label-placeholder="Número de mesas"
                v-model="restaurantForm.number_tables"
                type="number"
                min="0"
                required="true"
                class="w-full"
              />
              </ValidationProvider>
            </vx-input-group>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <vx-input-group class="mb-5 mt-3">
              <ValidationProvider name="Suplemento terraza" rules="required|min_value:0" v-slot="{ errors }">
                <vs-input
                  label-placeholder="Suplemento terraza"
                  v-model="restaurantForm.terrace_supplement"
                  type="number"
                  min="0"
                  step="0.01"
                  class="w-full"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </ValidationProvider>
            </vx-input-group>
          </div>
          <div class="vx-col w-full mt-6 mb-3">
            <h4 class="text-uppercase font-bold text-xl">{{ $t('restaurant.MetodosDePago') }}</h4>
          </div>
          <div class="vx-col w-full">
            <div class="vx-row">
              <div class="vx-col md:w-2/12 w-full mb-3">
                <label class="mt-2">{{ $t('restaurant.PagoTarjeta') }}</label>
                <vs-switch v-model="restaurantForm.card_payment" />
              </div>
              <div class="vx-col md:w-2/12 w-full mb-3">
                <label class="mt-2">{{ $t('restaurant.PagoEfectivo') }}</label>
                <vs-switch v-model="restaurantForm.cash_payment" />
              </div>
            </div>
          </div>
          <div class="vx-col w-full mt-6 mb-3">
            <h4 class="text-uppercase font-bold text-xl">{{ $t('Horario') }}</h4>
          </div>
          <div class="vx-col w-full">
            <div class="vx-row">
              <div class="vx-col md:w-2/12 w-full flex items-center"></div>
              <div class="vx-col md:w-4/12 w-full">
                <p>{{ $t('HorarioManyana') }}</p>
              </div>
              <div class="vx-col md:w-4/12 w-full">
                <p>{{ $t('HorarioTarde') }}</p>
              </div>
            </div>
            <div class="vx-row mt-3 items-center" v-if="restaurantForm.schedules" v-for="(values, day) in restaurantForm.schedules" :key="day">
              <div class="vx-col md:w-2/12 w-full flex items-center">
                <p>{{ translateDays[day] }}</p>
              </div>
              <div class="vx-col md:w-4/12 w-full">
                <vx-input-group class="">
                <TimeRangeInput :disabled="closeArray[day] === true" :value="{fromTime: values.open[0], toTime: values.close[0]}" @input="getInputValueMorning($event, values, day)"></TimeRangeInput>
                </vx-input-group>
              </div>
              <div class="vx-col md:w-4/12 w-full">
                <vx-input-group class="">
              <TimeRangeInput :disabled="closeArray[day] === true" :value="{fromTime: values.open[1], toTime: values.close[1]}" @input="getInputValueEvening($event, values, day)"></TimeRangeInput>
                </vx-input-group>
              </div>
              <div class="vx-col md:w-2/12 w-full">
                <vx-input-group class="">
                  <label class="mt-2">{{ $t('Cerrado') }}</label>
                  <vs-switch v-model="closeArray[day]" />
                </vx-input-group>
              </div>
            </div>
          </div>
          <div class="vx-col w-full mt-6 mb-3">
            <h4 class="text-uppercase font-bold text-xl">ERP</h4>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <vx-input-group class="mb-5 mt-3">
              <vs-input label-placeholder="Nombre" v-model="restaurantForm.name_erp" required="true" class="w-full" />
            </vx-input-group>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <vx-input-group class="mb-5 mt-3">
              <vs-input
                label-placeholder="Fabricante"
                v-model="restaurantForm.manufacturer_erp"
                required="true"
                class="w-full"
              />
            </vx-input-group>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <vx-input-group class="mb-5 mt-3">
              <vs-input
                label-placeholder="Versión"
                v-model="restaurantForm.version_erp"
                required="true"
                class="w-full"
              />
            </vx-input-group>
          </div>
          <div class="vx-col w-full mt-6 mb-3">
            <h4 class="text-uppercase font-bold text-xl">{{ $t('DatosFiscales') }}</h4>
          </div>
          <div class="vx-col w-full mt-3">
            <h6>{{ $t('DireccionFacturacion') }}</h6>
          </div>
          <div class="vx-col md:w-2/3 w-full">
            <vx-input-group class="mb-5 mt-3">
              <ValidationProvider name="Dirección" rules="" v-slot="{ errors }">
                <vs-input
                  label-placeholder="Dirección"
                  v-model="restaurantForm.address_invoice"
                  required="true"
                  class="w-full"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </ValidationProvider>
            </vx-input-group>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <vx-input-group class="mb-5 mt-3">
              <ValidationProvider name="Código postal" rules="" v-slot="{ errors }">
                <vs-input
                  label-placeholder="Código postal"
                  v-model="restaurantForm.cp_invoice"
                  required="true"
                  class="w-full"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </ValidationProvider>
            </vx-input-group>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <vx-input-group class="mb-5 mt-3">
              <ValidationProvider name="Municipio" rules="" v-slot="{ errors }">
                <vs-input
                  label-placeholder="Municipio"
                  v-model="restaurantForm.municipality_invoice"
                  required="true"
                  class="w-full"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </ValidationProvider>
            </vx-input-group>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <vx-input-group class="mb-5 mt-3">
              <ValidationProvider name="Provincia" rules="" v-slot="{ errors }">
                <vs-input
                  label-placeholder="Provincia"
                  v-model="restaurantForm.province_invoice"
                  required="true"
                  class="w-full"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </ValidationProvider>
            </vx-input-group>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <vx-input-group class="mb-5 mt-3">
              <ValidationProvider name="País" rules="" v-slot="{ errors }">
                <vs-input
                  label-placeholder="País"
                  v-model="restaurantForm.country_invoice"
                  required="true"
                  class="w-full"
                />
                <p class="text-danger">{{ errors[0] }}</p>
              </ValidationProvider>
            </vx-input-group>
          </div>
          <div class="vx-col w-full mt-3">
            <h6>{{ $t('SerieFactura') }}</h6>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <vx-input-group class="mb-5 mt-3">
              <vs-input
                label-placeholder="Serie"
                v-model="restaurantForm.invoice_serie"
                required="true"
                class="w-full"
              />
            </vx-input-group>
          </div>
          <div class="vx-col md:w-3/3 w-full">
            <p style="color: rgba(var(--vs-danger), 1) !important">
              <font-awesome-icon class="mr-2 ml-2" :icon="['fa', 'exclamation-triangle']" />
              {{ $t('AvisoCambioSerieFacturacion') }}
            </p>
          </div>
          <div class="vx-col w-full mt-6 mb-3">
            <h4 class="text-uppercase font-bold text-xl">{{ $t('ImagenCabecera') }}</h4>
          </div>
          <div class="vx-col w-full">
            <vx-input-group class="mb-2 mt-3">
              <ImageDropzone ref="images" :files="files"></ImageDropzone>
            </vx-input-group>
          </div>
          <div class="vx-col w-full mt-3 text-right">
            <router-link :to="{ name: 'restaurant' }">
              <vs-button type="border" color="secondary" class="mr-2">
                {{ $t('Cancelar') }}
              </vs-button>
            </router-link>
            <vs-button
              type="filled"
              color="primary"
              @click="handleSubmit"
              class="btn-primary btn--xlarge-auto font-weight-bold"
            >
              {{ $t('Guardar') }}
            </vs-button>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import ImageDropzone from '../ImageDropzone';
import TimeRangeInput from '../time-range-input/TimeRangeInput.vue';

export default {
  props: {
    restaurant: {
      type: Object,
      required: true,
    },
  },
  components: {
    ImageDropzone,
    TimeRangeInput
  },
  data () {
    return {
      schedulesMorning: {
        Monday: {
          open: '',
          close: '',
        },
        Tuesday: {
          open: '',
          close: '',
        },
        Wednesday: {
          open: '',
          close: '',
        },
        Thursday: {
          open: '',
          close: '',
        },
        Friday: {
          open: '',
          close: '',
        },
        Saturday: {
          open: '',
          close: '',
        },
        Sunday: {
          open: '',
          close: '',
        },
      },
      schedulesEvening: {
        Monday: {
          open: '',
          close: '',
        },
        Tuesday: {
          open: '',
          close: '',
        },
        Wednesday: {
          open: '',
          close: '',
        },
        Thursday: {
          open: '',
          close: '',
        },
        Friday: {
          open: '',
          close: '',
        },
        Saturday: {
          open: '',
          close: '',
        },
        Sunday: {
          open: '',
          close: '',
        },
      },
      restaurantForm: {},
      restaurantFormOriginal: {},
      files: {},
      translateDays: {
        Monday: 'Lunes',
        Tuesday: 'Martes',
        Wednesday: 'Miércoles',
        Thursday: 'Jueves',
        Friday: 'Viernes',
        Saturday: 'Sábado',
        Sunday: 'Domingo',
      },
      closeArray: {
        Monday: true,
        Tuesday: true,
        Wednesday: true,
        Thursday: true,
        Friday: true,
        Saturday: true,
        Sunday: true,
      },
      canChangeLanguage: false,
      restaurantCurrentLanguage: 0,
    };
  },
  created () {
    this.getAllTypesRestaurantForSelect(this.language);
    this.getAllProfilesRestaurantForSelect(this.language);
    this.getAllLanguagesRestaurantForSelect(this.language);
    this.restaurantForm = this.createRestaurantForm(this.restaurant);
    this.restaurantFormOriginal = JSON.stringify(this.createRestaurantForm(this.restaurant));
    const files = new Array();
    if (this.restaurantForm.images) {
      this.restaurantForm.images.forEach(function (element) {
        const image = {
          name: element.path,
          url: element.path,
          urlDelete: `/webadmin/restaurants/delete_image/${element.id}`,
        };
        files.push(image);
      });
    }
    this.files = files;
  },
  computed: {
    ...mapGetters({
      languages: 'getLanguages',
      listTypes: 'getListTypeRestaurant',
      listProfiles: 'getListProfileRestaurant',
      listLanguages: 'getListLanguagesRestaurant',
      language: 'getCurrentLanguage',
    }),
    latitudeCalculate: {
      get () {
        return this.$store.getters.getLatitudeCalculate;
      },
      set (val) {
        this.$store.commit('setCoordinatesLat', val);
      },
    },
    longitudeCalculate: {
      get () {
        return this.$store.getters.getLongitudeCalculate;
      },
      set (val) {
        this.$store.commit('setCoordinatesLng', val);
      },
    },
  },
  methods: {
    ...mapActions({
      editRestaurant: 'editRestaurant',
      calculateCoordinates: 'calculateCoordinates',
      getAllProfilesRestaurantForSelect: 'getAllProfilesRestaurantForSelect',
      getAllTypesRestaurantForSelect: 'getAllTypesRestaurantForSelect',
      getAllLanguagesRestaurantForSelect: 'getAllLanguagesRestaurantForSelect',
      getRestaurant: 'getRestaurant',
    }),
    ...mapMutations({
      loading: 'loading',
      setCoordinatesLat: 'setCoordinatesLat',
      setCoordinatesLng: 'setCoordinatesLng',
    }),
    createRestaurantForm (restaurant) {
      const typesArray = new Array();
      const profilesArray = new Array();
      const languagesArray = new Array();
      const schedulesArray = {
        Monday: {
          open: [],
          close: [],
        },
        Tuesday: {
          open: [],
          close: [],
        },
        Wednesday: {
          open: [],
          close: [],
        },
        Thursday: {
          open: [],
          close: [],
        },
        Friday: {
          open: [],
          close: [],
        },
        Saturday: {
          open: [],
          close: [],
        },
        Sunday: {
          open: [],
          close: [],
        },
      };

      const auxScheduleMorning = this.schedulesMorning;
      const auxScheduleEvening = this.schedulesEvening;

      if (restaurant.types.length > 0) {
        restaurant.types.forEach(function (element) {
          typesArray.push(element.id);
        });
      }
      if (restaurant.profiles.length > 0) {
        restaurant.profiles.forEach(function (element) {
          profilesArray.push(element.id);
        });
      }
      if (restaurant.languages) {
        const auxLang = JSON.parse(restaurant.languages);
        if (auxLang.length > 0) {
          auxLang.forEach(function (element) {
            languagesArray.push(element);
          });
        }
      }
      if (restaurant.schedule) {
        const auxClose = this.closeArray;
        restaurant.schedule.forEach(function (element) {
          let empty = true;
          if (element.open[0]) {
            schedulesArray[element.day].open[0] = element.open[0];
            auxScheduleMorning[element.day].open = element.open[0];
            empty = false;
          }
          if (element.close[0]) {
            schedulesArray[element.day].close[0] = element.close[0];
            auxScheduleMorning[element.day].close = element.close[0];
            empty = false;
          }
          if (element.open[1]) {
            schedulesArray[element.day].open[1] = element.open[1];
            auxScheduleEvening[element.day].open = element.open[1];
            empty = false;
          }
          if (element.close[1]) {
            schedulesArray[element.day].close[1] = element.close[1];
            auxScheduleEvening[element.day].close = element.close[1];
            empty = false;
          }
          auxClose[element.day] = empty;
        });
      }

      this.schedulesMorning = auxScheduleMorning;
      this.schedulesEvening = auxScheduleEvening;

      const arrayAllowedLanguages = eval(restaurant.allowed_languages);
      if(arrayAllowedLanguages&&arrayAllowedLanguages!==undefined){
        for (let i = 0; arrayAllowedLanguages.length > i; i++) {
          if (arrayAllowedLanguages[i] === restaurant.current_language) {
            this.restaurantCurrentLanguage = i;
            this.canChangeLanguage = true;
          }
        }
    }
      this.setCoordinatesLat(restaurant.latitude);
      this.setCoordinatesLng(restaurant.longitude);
      return {
        id: restaurant.id,
        slug: restaurant.slug,
        address: restaurant.address,
        animation: restaurant.animation,
        capacity: restaurant.capacity,
        card_payment: restaurant.card_payment,
        cash_payment: restaurant.cash_payment,
        cif: restaurant.cif,
        company_name: restaurant.company_name,
        country: restaurant.country,
        covid_free: restaurant.covid_free,
        description: restaurant.description,
        digital_menu: restaurant.digital_menu,
        email: restaurant.email,
        food_delivery: restaurant.food_delivery,
        images: restaurant.images,
        iva: restaurant.iva,
        kid_friendly: restaurant.kid_friendly,
        kid_area: restaurant.kid_area,
        municipality: restaurant.municipality,
        name: restaurant.name,
        number_tables: restaurant.number_tables,
        parking: restaurant.parking,
        pet_friendly: restaurant.pet_friendly,
        phone_bookings: restaurant.phone_bookings,
        phone_management: restaurant.phone_management,
        whatsapp: restaurant.whatsapp,
        pmr: restaurant.pmr,
        pool: restaurant.pool,
        postalCode: restaurant.postalCode,
        prices: restaurant.prices,
        privatizable: restaurant.privatizable,
        profiles: profilesArray,
        province: restaurant.province,
        responsable_name: restaurant.responsable_name,
        responsable_phone: restaurant.responsable_phone,
        responsable_position: restaurant.responsable_position,
        responsable_name_2: restaurant.responsable_name_2,
        responsable_phone_2: restaurant.responsable_phone_2,
        responsable_position_2: restaurant.responsable_position_2,
        terrace: restaurant.terrace,
        terrace_supplement: restaurant.terrace_supplement,
        wifi: restaurant.wifi,
        name_erp: restaurant.name_erp,
        version_erp: restaurant.version_erp,
        manufacturer_erp: restaurant.manufacturer_erp,
        languages: languagesArray,
        schedules: schedulesArray,
        types: typesArray,
        web: restaurant.web,
        invoice_serie: restaurant.invoice_serie,
        allowedLanguages: arrayAllowedLanguages,
        currentLanguage: restaurant.current_language,
        address_invoice: restaurant.address_invoice,
        country_invoice: restaurant.country_invoice,
        cp_invoice: restaurant.cp_invoice,
        province_invoice: restaurant.province_invoice,
        municipality_invoice: restaurant.municipality_invoice,
      };
    },
    handleSubmit (newLang = '', currentLang = '') {
      if (currentLang === '') currentLang = this.restaurantCurrentLanguage;
      this.$refs.form.validate().then((success) => {
        if (!success) {
          setTimeout(() => {
            let textAux = '';
            const errors = this.$refs.form.errors;
            Object.keys(errors).forEach((key) => {
              const error = errors[key];
              if (error.length) {
                error.forEach(function (text) {
                  textAux += `<p>${text}</p>`;
                });
              }
            });
            this.$store.commit('notifications', {
              title: 'Existen errores en el formulario.',
              color: 'danger',
              text: textAux,
            });
            this.$store.commit('showNotifications', true);
            this.restaurantCurrentLanguage = currentLang;
            this.canChangeLanguage = true;
          }, 100);
          return;
        }

        this.submitted = true;

        const formData = this.createFormData();

        this.editRestaurant({
          id: this.restaurantForm.id,
          restaurant: formData,
          language: this.restaurantForm.currentLanguage,
          newLanguage: newLang,
        });

        // Wait until the models are updated in the UI
        this.$nextTick(() => {
          this.$refs.form.reset();
        });
      });
    },
    createFormData () {
      const data = this.$refs.images.getFormData();
      data.append('slug', this.restaurantForm.slug);
      data.append('name', this.restaurantForm.name);
      data.append('web', this.restaurantForm.web);
      data.append('description', this.restaurantForm.description);
      data.append('company_name', this.restaurantForm.company_name);
      data.append('cif', this.restaurantForm.cif);
      data.append('email', this.restaurantForm.email);
      data.append('phone_management', this.restaurantForm.phone_management);
      data.append('phone_bookings', this.restaurantForm.phone_bookings);
      data.append('whatsapp', this.restaurantForm.whatsapp);
      data.append('prices', this.restaurantForm.prices);

      data.append('responsable_name', this.restaurantForm.responsable_name);
      data.append('responsable_phone', this.restaurantForm.responsable_phone);
      data.append('responsable_position', this.restaurantForm.responsable_position);
      data.append('responsable_name_2', this.restaurantForm.responsable_name_2);
      data.append('responsable_phone_2', this.restaurantForm.responsable_phone_2);
      data.append('responsable_position_2', this.restaurantForm.responsable_position_2);

      data.append('country', this.restaurantForm.country);
      data.append('province', this.restaurantForm.province);
      data.append('address', this.restaurantForm.address);
      data.append('latitude', this.latitudeCalculate);
      data.append('longitude', this.longitudeCalculate);
      data.append('municipality', this.restaurantForm.municipality);
      data.append('postalCode', this.restaurantForm.postalCode);

      data.append('name_erp', this.restaurantForm.name_erp);
      data.append('version_erp', this.restaurantForm.version_erp);
      data.append('manufacturer_erp', this.restaurantForm.manufacturer_erp);

      data.append('terrace_supplement', this.restaurantForm.terrace_supplement);

      data.append('capacity', this.restaurantForm.capacity);
      data.append('iva', this.restaurantForm.iva);
      data.append('number_tables', this.restaurantForm.number_tables);

      data.append('invoice_serie', this.restaurantForm.invoice_serie);
      data.append('address_invoice', this.restaurantForm.address_invoice);
      data.append('country_invoice', this.restaurantForm.country_invoice);
      data.append('cp_invoice', this.restaurantForm.cp_invoice);
      data.append('province_invoice', this.restaurantForm.province_invoice);
      data.append('municipality_invoice', this.restaurantForm.municipality_invoice);

      const arrayTypes = this.restaurantForm.types;
      for (let i = 0; i < arrayTypes.length; i++) {
        data.append(`types[${i}]`, arrayTypes[i]);
      }

      const arrayProfiles = this.restaurantForm.profiles;
      for (let i = 0; i < arrayProfiles.length; i++) {
        data.append(`profiles[${i}]`, arrayProfiles[i]);
      }

      const arrayLanguages = this.restaurantForm.languages;
      const auxLanguages = this.listLanguages;
      const saveLanguages = new Array();
      for (let i = 0; i < arrayLanguages.length; i++) {
        auxLanguages.forEach(function (element) {
          if (element.id === arrayLanguages[i]) {
            saveLanguages.push(arrayLanguages[i]);
          }
        });
      }
      const valLanguages = `["${saveLanguages.join('","')}"]`;
      data.append('lang', valLanguages);

      const schedules = this.restaurantForm.schedules;
      const auxMorning = this.schedulesMorning;
      const auxEvening = this.schedulesEvening;
      let i = 0;
      for (const [key] of Object.entries(schedules)) {
        // eslint-disable-next-line sonarjs/prefer-object-literal
        const dayArray = {};
        dayArray.day = key;
        dayArray.open = [];
        dayArray.close = [];
        if (this.closeArray[key] === true) {
          dayArray.open = [];
          dayArray.close = [];
        } else {
          dayArray.open[0] = auxMorning[key].open ? auxMorning[key].open : '00:00';
          dayArray.close[0] = auxMorning[key].close ? auxMorning[key].close : '23:59';
          dayArray.open[1] = auxEvening[key].open ? auxEvening[key].open : '00:00';
          dayArray.close[1] = auxEvening[key].close ? auxEvening[key].close : '23:59';
        }
        data.append(`schedule[${i}]`, JSON.stringify(dayArray));
        i++;
      }

      let animation = 0;
      let card_payment = 0;
      let cash_payment = 0;
      let covid_free = 0;
      let digital_menu = 0;
      let food_delivery = 0;
      let kid_friendly = 0;
      let kid_area = 0;
      let parking = 0;
      let pet_friendly = 0;
      let pmr = 0;
      let pool = 0;
      let privatizable = 0;
      let terrace = 0;
      let wifi = 0;

      if (this.restaurantForm.animation) animation = 1;
      if (this.restaurantForm.card_payment) card_payment = 1;
      if (this.restaurantForm.cash_payment) cash_payment = 1;
      if (this.restaurantForm.covid_free) covid_free = 1;
      if (this.restaurantForm.digital_menu) digital_menu = 1;
      if (this.restaurantForm.food_delivery) food_delivery = 1;
      if (this.restaurantForm.kid_friendly) kid_friendly = 1;
      if (this.restaurantForm.kid_area) kid_area = 1;
      if (this.restaurantForm.parking) parking = 1;
      if (this.restaurantForm.pet_friendly) pet_friendly = 1;
      if (this.restaurantForm.pmr) pmr = 1;
      if (this.restaurantForm.pool) pool = 1;
      if (this.restaurantForm.privatizable) privatizable = 1;
      if (this.restaurantForm.terrace) terrace = 1;
      if (this.restaurantForm.wifi) wifi = 1;

      data.append('animation', animation);
      data.append('card_payment', card_payment);
      data.append('cash_payment', cash_payment);
      data.append('covid_free', covid_free);
      data.append('digital_menu', digital_menu);
      data.append('food_delivery', food_delivery);
      data.append('kid_friendly', kid_friendly);
      data.append('kid_area', kid_area);
      data.append('parking', parking);
      data.append('pet_friendly', pet_friendly);
      data.append('pmr', pmr);
      data.append('pool', pool);
      data.append('privatizable', privatizable);
      data.append('terrace', terrace);
      data.append('wifi', wifi);

      return data;
    },
    calculateCoordenadas () {
      if (
        this.restaurantForm.country === '' ||
        this.restaurantForm.postalCode === '' ||
        this.restaurantForm.address === ''
      ) {
        this.$store.commit('notifications', {
          title: 'No ha sido posible calcular sus coordenadas.',
          color: 'danger',
          text: 'Debes rellenar el campo país, dirección y código postal.',
        });
        this.$store.commit('showNotifications', true);
      } else {
        this.calculateCoordinates({
          country: this.restaurantForm.country,
          address: this.restaurantForm.address,
          postalCode: this.restaurantForm.postalCode,
        });
      }
    },
    clickTabChangeLang (value) {
      const arrayAllowedLanguages = this.restaurantForm.allowedLanguages;
      if (this.restaurantForm.currentLanguage !== value) {
        const currentLanguage = this.restaurantForm.currentLanguage;
        let indexCurrentLanguage = 0;
        for (let i = 0; arrayAllowedLanguages.length > i; i++) {
          if (arrayAllowedLanguages[i] === currentLanguage) {
            indexCurrentLanguage = i;
          }
        }
        this.changeLanguage(value, indexCurrentLanguage);
      }
    },
    changeLanguage (lang, currentIndex) {
      const aux = this;
      aux.canChangeLanguage = false;
      if (JSON.stringify(aux.restaurantForm) !== aux.restaurantFormOriginal) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'success',
          title: this.$t('changeLanguage'),
          text: this.$t('textChangeLanguage'),
          acceptText: aux.$t('SalirGuardar'),
          cancelText: aux.$t('Cancelar'),
          accept () {
            aux.handleSubmit(lang, currentIndex);
          },
          cancel () {
            aux.restaurantCurrentLanguage = currentIndex;
            aux.canChangeLanguage = true;
          },
        });
      } else {
        aux.loading(true);
        aux.getRestaurant({ id: aux.restaurantForm.id, language: lang });
        aux.loading(false);
      }
    },
    getInputValueMorning(event, values, day) {
      this.schedulesMorning[day].open = event.fromTime;
      this.schedulesMorning[day].close = event.toTime;
    },
    getInputValueEvening(event, values, day) {
      this.schedulesEvening[day].open = event.fromTime;
      this.schedulesEvening[day].close = event.toTime;
    }
  },
};
</script>
